export default __webpack_public_path__ + "static/media/FRTApp.7ee0ea4b.PNG";